// extracted by mini-css-extract-plugin
export var form = "_eh-0";